import React, { useState, useEffect, useRef } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./BookTickets.css";
import loader from "../../assests/loader.gif";
import API from "../../Utils/Api";
import { v4 as uuidv4 } from "uuid";
import Multiselect from "multiselect-react-dropdown";

const images = [
  "assests/images/romanticss-2.jpg",
  "assests/images/romantic-1.jpg",
  "assests/images/romanticss-3.jpg",
  "assests/images/romanticss-4.jpg",
];

const BookTickets = () => {

  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500, 
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    centerMode: false,
    centerPadding: '13%',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0',
        }
      }
    ]
  };


  const [loading, setLoading] = useState(true);

  const [category, setCategory] = useState([]);
  const [location, setLocation] = useState([]);
  const [events, setEvents] = useState([]);
  const [eventsfeature, setEventsfeature] = useState();


  const [selected, setSelected] = useState([]);

  const [selectedcat, setSelectedcat] = useState([]);


  useEffect(() => {
    document.title = `Upcoming Singles Events in Ireland`;
    document.getElementById("bodywrap").className = "book";

    const metaDesc = document.querySelector("meta[name='description']");
      if (metaDesc) {
        metaDesc.setAttribute("content", "Explore YFMF’s upcoming singles events, speed dating and parties in Dublin, Cork, Galway and Limerick. Book now and meet someone new in real life.");
      }

    let id = localStorage.getItem("device_id");
    if (!id) {
      id = uuidv4();
      localStorage.setItem("device_id", id);
    }

    /* Start get category data */
    API.get("get_category")
      .then((response) => {
        setLoading(false);
        if (response.data.status === false) {
        } else {
          const filteredData = response.data.data.map((item) => ({
            id: item.id,
            name: item.name,
          }));
          setCategory(filteredData);
        }
      })
      .catch((error) => {});
    /* End get category data */

    /* Start get location data */
    API.get("get_location")
      .then((response) => {
        if (response.data.status === false) {
        } else {
          setLocation(response.data.data);
        }
      })
      .catch((error) => {});
    /* End get location data */

    /* Start get even data */
    let formData = new FormData();
    formData.append("type", "all");
    API.post("get_events", formData)
      .then((response) => {
        setLoading(false);
        if (response.data.status === false) {
        } else {
          setEvents(response.data.data.event);
          setEventsfeature(response.data.data.featured_event);
        }
      })
      .catch((error) => {});
    /* End get even data */
  }, []);

  const handleInputChangeLoc = (selectedList) => {
    //selectedList.persist();
    setSelected(selectedList);

    const allNewCat = [];
    selectedcat.forEach((val) => {
      allNewCat.push(val.id);
    });

    const allNewLoc = [];
    selectedList.forEach((val) => {
      allNewLoc.push(val.id);
    });

    let formData = new FormData();
    formData.append("type", "all");

    formData.append("location_id", JSON.stringify(allNewLoc));

    formData.append("category_id", JSON.stringify(allNewCat));

    API.post("get_events", formData)
      .then((response) => {
        setLoading(false);
        if (response.data.status === false) {
        } else {
          setEvents(response.data.data.event);
        }
      })
      .catch((error) => {});
  };
  const handleInputChangeCat = (selectedList) => {
    //selectedList.persist();
    setSelectedcat(selectedList);
    console.log(selectedList);
    const allNewCat = [];
    selectedList.forEach((val) => {
      allNewCat.push(val.id);
    });

    const allNewLoc = [];
    selected.forEach((val) => {
      allNewLoc.push(val.id);
    });

    let formData = new FormData();
    formData.append("type", "all");
    formData.append("category_id", JSON.stringify(allNewCat));

    formData.append("location_id", JSON.stringify(allNewLoc));

    API.post("get_events", formData)
      .then((response) => {
        setLoading(false);
        if (response.data.status === false) {
        } else {
          setEvents(response.data.data.event);
        }
      })
      .catch((error) => {});
  };

const handleLink = (is_event_private,id) => {
      window.location.href = "/event-product/"+id;
}

  return (
    <>
      <Header />
      <div className="hello-worldss d-flex justify-content-center align-items-center">
        <img
          src={
            process.env.REACT_APP_BASE_URL + "assests/images/singles-news.jpg"
          }
          alt=""
          className="img-fluid"
        />
      </div>
      {eventsfeature && (
      <div className="container-fluid up-even new">
          <div className="row align-items-center g-4">
            <div className="col-lg-8">
              <img
                src={
                  eventsfeature.image
                }
                alt={eventsfeature.title}
                className="img-fluid"
              />
            </div>
            <div className="col-lg-4">
              <h4>FEATURED EVENT</h4>
              <h2>{eventsfeature.title}</h2>
              <p className="mb-4">{eventsfeature.description}</p>
              <Link to={eventsfeature.btn_link ? eventsfeature.btn_link : "#"} target="_blank" className="d-inline-block">LEARN MORE</Link>
            </div>
          </div>
      </div>
      )}
      <div className="container-fluid up-even new d-none">
<div className="row">
  <div className="col-12">
    <Slider ref={sliderRef} {...settings}>
      {images.map((img, i) => (
        <div key={i} className="custom-slide">
          <div className="row align-items-center g-4">
            {/* Left: 8 columns */}
            <div className="col-lg-8">
              <img
                src={process.env.REACT_APP_BASE_URL + img}
                className="img-fluid respo"
                alt={`Slide ${i + 1}`}
                style={{
                  width: "100%",
                  height: "460px",
                  borderRadius: 24,
                  objectFit: "cover",
                }}
                onError={(e) => (e.target.style.display = "none")}
              />
            </div>

            {/* Right: 4 columns */}
            <div className="col-lg-4">
              <h4>FEATURED EVENT</h4>
              <h2>
                YFMF is coming to Punchestown Festival with our largest
                singles event ever!
              </h2>
              <p className="mb-4">
                Join over 500 singles in the YFMF Pavilion, set above the
                racecourse for the season’s most celebrated social occasion.
              </p>
              <Link to="/punchestownfestival" className="d-inline-block">
                LEARN MORE
              </Link>
            </div>
          </div>
        </div>
      ))}
    </Slider>

    {/* Slider navigation */}
    <div className="d-none d-md-flex justify-content-start">
      <button
        className="btn"
        onClick={() => sliderRef.current?.slickPrev()}
      >
        Previous
      </button>

      <button
        className="btn"
        onClick={() => sliderRef.current?.slickNext()}
      >
        Next
      </button>
    </div>
  </div>
</div>
      </div>

      <div className="container-fluid discover up-even">
        <div className="row filter align-items-center mt-4">
          <h2>Upcoming Events</h2>
          <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3">
            <div className="col-12 col-md-auto files">Filter by</div>
            <div className="d-flex flex-column flex-md-row gap-2 alag">
              <div className="col-12 col-md-6 fil-name mb-2 mb-md-0">
                <Multiselect
                  options={location}
                  selectedValues={selected} // Here you put your pre-selected values
                  onSelect={handleInputChangeLoc}
                  onRemove={handleInputChangeLoc}
                  displayValue="name"
                  showCheckbox
                  placeholder="Select Location"
                />
              </div>
              <div className="col-12 col-md-6 fil-name">
                <Multiselect
                  options={category}
                  selectedValues={selectedcat} // Here you put your pre-selected values
                  onSelect={handleInputChangeCat}
                  onRemove={handleInputChangeCat}
                  displayValue="name"
                  showCheckbox
                  placeholder="Select Type of Event"
                />
              </div>
            </div>
          </div>
        </div>
        {events.length > 0 ? (
          <div className="row g-4">
            {events &&
              events.map((val, index) => {
                return (
                  <div className="col-md-4 mb-4 joker">
                    <div className="card orama h-100 position-relative">
                      <Link
                        to="#"
                        className="text-decoration-none"
                        onClick={() => handleLink(val.is_event_private,val.id)}
                      >
                        <img
                          src={val.event_image}
                          className="card-img-top"
                          alt={val.event_title}
                        />
                      </Link>
                      <h5 class={`text-center event-cat-box${val.category_id}`}>
                        {val.category_name}
                      </h5>
                      <div className="card-body d-flex flex-column">
                      <div className="datesx">
                        <div className="day-number">{val.day}</div>
                        <div className="day-month">{val.month}</div>  
                      </div>
                        <Link
                          to="#"
                          className="text-decoration-none"
                          onClick={() => handleLink(val.is_event_private,val.id)}
                        >
                          <h5>
                            {val.event_title}{" "}
                            {/*(Ages {val.age_start} - {val.age_end})*/}
                          </h5>
                        </Link>
                        <p>{val.event_address}</p>
                        <div className="d-flex gap-2 flex-wrap">
                        {(() => {
                if (val.age_start==='' && val.age_end==='') {
                  } else if (val.age_start!=='' && val.age_end==='') {
                    return ( <h3>Age {val.age_start}+</h3>)
                  }else if (val.age_start==='' && val.age_end!=='') {
                      return ( <h3>Age {val.age_end}+</h3>)
                  }else if (val.age_start!=='' && val.age_end!=='') {
                    return ( <h3>Ages {val.age_start} - {val.age_end}</h3>)
                  }
                })()}
              {val.tags.map((val1, index1) => {
                return (
                <h3>{val1}</h3>
              )
              })}
              </div>
              <div className="mt-auto">
                        <Link
                          to="#"
                          className="text-decoration-none"
                          onClick={() => handleLink(val.is_event_private,val.id)}
                        >
                          <div className="get-ti">
                            <Link
                              to="#"
                              className="w-100 text-decoration-none"
                            >
                              GET TICKETS
                            </Link>
                          </div>
                        </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        ) : (
          <div className="row g-4">
            <div className="col-md-12 mb-4">
              <p className="text-center mt-4">No data found</p>
            </div>
          </div>
        )}

        <div className="get-miss">
          <div className="row d-flex align-items-strech g-4">
            {/* Image Section */}
            <div className="col-md-8 od-1 d-flex">
              <img
                src={
                  process.env.REACT_APP_BASE_URL +
                  "assests/images/single-event.png"
                }
                alt="Event Promo"
                className="img-fluid eve-img"
              />
            </div>

            {/* Text Section */}
            <div className="col-md-4 od-2 d-flex">
              <div className="get-app text-center d-flex flex-column align-items-center justify-content-center w-100">
                <h2>GET THE APP</h2>
                <h3>Don’t miss a single event</h3>
                <p>
                  Get early access to tickets, receive exclusive event
                  notifications, and chat with attendees after the event to keep
                  the conversation going.
                </p>
                <div className="d-flex justify-content-center gap-3">
                  <Link
                    to="#"
                    onClick={(e) => e.preventDefault()}
                    className="store-link"
                  >
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "assests/images/app-store.png"
                      }
                      alt="Event Promo"
                      className="img-fluid store-image store-image-1"
                    />
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "assests/images/app-store-hover.png"
                      }
                      alt="Event Promo Hover"
                      className="img-fluid store-image store-image-2"
                    />
                  </Link>
                  <Link
                    to="#"
                    onClick={(e) => e.preventDefault()}
                    className="store-link"
                  >
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "assests/images/google-store.png"
                      }
                      alt="Event Promo"
                      className="img-fluid store-image store-image-1"
                    />
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "assests/images/google-store-hover.png"
                      }
                      alt="Event Promo Hover"
                      className="img-fluid store-image store-image-2"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="conainer-fluid accors" style={{ background: "#fbf9f4" }}>
          <div className="row">
            <div className="col-md-6">
              <h2>FAQ</h2>
              <h3>Any questions?</h3>
            </div>
            <div className="col-md-6">
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    How often do you release new singles events?
                  </Accordion.Header>
                  <Accordion.Body>
                    We release new events regularly, often every month. The best
                    way to stay informed and get early access to tickets is by
                    downloading the YFMF app or joining our mailing list. Our
                    most popular events, including Speed Dating and Singles
                    Parties, tend to sell out quickly.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    How far in advance should I book a ticket for a singles
                    event?
                  </Accordion.Header>
                  <Accordion.Body>
                    We recommend booking as early as possible. Many of our
                    events, especially Speed Dating and curated singles events,
                    sell out weeks in advance. Early bird tickets are sometimes
                    available for certain events, so it’s worth booking early to
                    avoid missing out.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    What happens if the event I want to attend is sold out?
                  </Accordion.Header>
                  <Accordion.Body>
                    If an event is sold out, you can join the waitlist through
                    our website or YFMF app. If spaces become available, we
                    notify people on the waitlist in order of sign-up.
                    Occasionally, door tickets are released closer to the event,
                    so keep an eye on your email and app notifications.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Can I book multiple tickets for friends?
                  </Accordion.Header>
                  <Accordion.Body>
                    Yes, you can purchase multiple tickets for friends. When
                    booking, you’ll need to provide the name and email for each
                    person attending. This ensures we can include everyone on
                    the guest list and give them access to any post-event
                    features, like chat through the app.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    Do I need to create an account to book an event?
                  </Accordion.Header>
                  <Accordion.Body>
                    No account is needed when booking directly through our
                    website. However, booking through the YFMF app gives you
                    early access to events and exclusive post-event features
                    like chatting with other attendees.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    What information do I need to provide when booking a ticket?
                  </Accordion.Header>
                  <Accordion.Body>
                    When booking, you’ll typically need to provide your name,
                    email address, phone number, and sometimes answers to
                    event-specific questions (for example, dietary requirements
                    for dinners).
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                  <Accordion.Header>
                    Do you ever provide discount tickets for singles events?
                  </Accordion.Header>
                  <Accordion.Body>
                    We never discount our tickets. After all, you can't put a
                    price on love!
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="7">
                  <Accordion.Header>
                    Can I transfer my ticket to another YFMF event?
                  </Accordion.Header>
                  <Accordion.Body>
                    If you’re unable to attend an event you’ve booked, let us
                    know at least 48 hours before the event and we can refund
                    your ticket.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="8">
                  <Accordion.Header>
                    Can I see who else is attending an upcoming event?
                  </Accordion.Header>
                  <Accordion.Body>
                    For privacy reasons, attendee lists aren’t shared. However,
                    after attending the event, you’ll have the opportunity to
                    chat with other attendees through the YFMF app (for
                    participating events like our larger Singles Parties).
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="9">
                  <Accordion.Header>
                    How do I know if an event is suitable for my age group?
                  </Accordion.Header>
                  <Accordion.Body>
                    Each event listing specifies the intended age range. We
                    offer events tailored to different groups, such as ages
                    25-35, 30-40, and 40+. Be sure to check the event details
                    before booking to ensure the event is the right fit. If you
                    book a ticket that is not suitable for your age, we may
                    contact you to cancel and refund your ticket.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="10">
                  <Accordion.Header>
                    What if I have dietary requirements for an event?
                  </Accordion.Header>
                  <Accordion.Body>
                    If the event includes food (like a wine tasting or dinner),
                    we ask for dietary requirements at the time of booking. We
                    do our best to accommodate all requests, but it’s important
                    to provide this information in advance.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="11" className="hololast">
                  <Accordion.Header>
                    How do I get early access to tickets for upcoming events?
                  </Accordion.Header>
                  <Accordion.Body>
                    Early access is available through the YFMF app. App users
                    receive advance notice of new events and have the chance to
                    book tickets before they’re released to the public. Join our
                    mailing list as well for updates and announcements.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
      </div>

      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
      <Footer />
    </>
  );
};

export default BookTickets;
